<template>
    <div class="feedback-explain">
        <body-feedback 
            :index="index"
            :beforeBold="$t('views.feedback.explain.beforeBold')"
            actionName="sendExplain">
            <text-area-default
                :placeholder="$t('views.feedback.explain.placeholder')">
            </text-area-default>
        </body-feedback>
        <span class="problem-desc"
        :style="{ 
            color: colors.theme == 'dark' ? '#fff' : '#000',
        }">{{$t('views.feedback.explain.problemDesc')}}</span>
        <div class="button button-feedback" @click="mailto()">
            <button
            :style="{ 
                color: colors.theme == 'dark' ? '#fff' : '#000',
                'background' : 'none',
                'border': colors.theme == 'dark' ? '1px solid #fff' : '1px solid #000',
                'border-bottom' : colors.theme == 'dark' ? '1px solid #fff' : '1px solid #000'
            }">{{$t('views.dashboard.textButton2')}}</button>    
        </div>           
    </div>
</template>
<script>
import BodyFeedback from '../../components/feedback/BodyFeedback.vue'
import TextAreaDefault from '../../components/shared/default/TextAreaDefault'
import { Bus } from '../../event-bus.js'
export default {
    components:{
        BodyFeedback,
        TextAreaDefault
    },
    data: function(){
        return{colors:{}}
    },
    props:["index"],
    created(){
        Bus.$on('sendExplain', this.sendExplain)
        this.colors = JSON.parse(localStorage.getItem("colors"));
    },
    mounted(){
        Bus.$emit('ableButton')
    },
    destroyed(){
        Bus.$off('sendExplain')
    },
    methods : {
        mailto(){
            window.location.href='mailto:support@huddlebrasil.zendesk.com'
        },
        sendExplain(){
            this.$store.dispatch('callSetFeedback', {
                itemName : 'testimonial',
                itemData : textArea.value
            })
            this.$router.push('/feedback-finish')
            Bus.$emit('nextStep')
        }
    }
}
</script>
<style lang="scss">
    .feedback-explain .body-feedback{
        overflow: hidden;
        margin-bottom: 32px;
    }
    .problem-desc{
        margin: 0 auto;
        padding: 0 32px 32px;
        display: flex;
        font-size: 15px;
        text-align: center;
        justify-content: center;
    }
    .body-feedback .content-feedback .text-area-default .text-area{
        overflow-y: auto;
        height: 150px;
    }    
    .feedback-explain{
        width: 100%;
        height: 100%;

        .title{
            font-weight: 600;
        }
        .button-feedback{
            // height: 40px;
            border: none;
            font-weight: bold;
            font-size: 30px;
            outline: none;
            letter-spacing: 2px;
            cursor: pointer;
            text-transform: uppercase;
            border-radius: 15px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;    
            
            button{
                max-width: 270px;
                border-radius: 300px;            
                width: 100%;
                font-weight: 900;
                text-transform: uppercase;
                font-size: 12px;
                padding: 15px;
            }
        }
        .button.button-feedback button{
            margin-bottom: 15px;
        }      
    }
</style>
